export default __webpack_public_path__ + "7067692697fd840b6e8ceaeaf7199088.png";